import styled from 'styled-components'
import { Box, Button, Flex, Text, Image, useMatchBreakpoints } from '@pancakeswap/uikit'
import { useAppDispatch } from 'state'
import { useAllSortedRecentTransactions } from 'state/transactions/hooks'
import { useTranslation } from '@pancakeswap/localization'
import { clearAllTransactions } from 'state/transactions/actions'
import isEmpty from 'lodash/isEmpty'
import TransactionRow from './TransactionRow'

import { chains } from '../../../utils/wagmi'

const ContainerBox = styled(Box)`
  @media not screen and (max-width: 1280px) {
    min-width: 508px;
  }
  .f-16 {
    color: var(--unnamed, #ffc9b1);
    text-align: right;
    /* 16px/Medium */
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 100%;
  }
`

const TransactionsContainer = styled(Box)`
  max-height: 300px;
  overflow-y: auto;
`

interface WalletTransactionsProps {
  onDismiss: () => void
}

const WalletTransactions: React.FC<React.PropsWithChildren<WalletTransactionsProps>> = ({ onDismiss }) => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const sortedTransactions = useAllSortedRecentTransactions()

  const hasTransactions = !isEmpty(sortedTransactions)

  const handleClearAll = () => {
    dispatch(clearAllTransactions())
  }
  const ifMobile = useMatchBreakpoints()

  return (
    <>
      <ContainerBox
        minHeight="120px"
        // style={
        //   ifMobile
        //     ? {
        //         minWidth: 'auto',
        //       }
        //     : {
        //         minWidth: '400px',
        //       }
        // }
      >
        <Flex alignItems="center" justifyContent="space-between" mb="16px">
          <div />
          {/* <Text color="secondary" fontSize="12px" textTransform="uppercase" fontWeight="bold"> */}
          {/* {t('Recent Transactions')} */}
          {/* </Text> */}
          {hasTransactions && (
            <Button
              scale="sm"
              onClick={handleClearAll}
              variant="text"
              px="0"
              className="f-16"
              style={{ height: 'fit-content' }}
            >
              {t('Clear all')}
            </Button>
          )}
        </Flex>
        {hasTransactions ? (
          <TransactionsContainer>
            {Object.entries(sortedTransactions).map(([chainId, transactions]) => {
              const chainIdNumber = Number(chainId)
              return (
                <Box key={chainId}>
                  {/* <Text fontSize="12px" color="textSubtle" mb="4px">
                  {chains.find((c) => c.id === chainIdNumber)?.name ?? 'Unknown network'}
                </Text> */}
                  <>
                    {Object.values(transactions).map((txn) => (
                      <TransactionRow
                        key={txn.hash}
                        txn={txn}
                        chainId={chainIdNumber}
                        type={txn.type}
                        onDismiss={onDismiss}
                        chainName={chains.find((c) => c.id === chainIdNumber)?.name ?? 'Unknown network'}
                      />
                    ))}
                  </>
                </Box>
              )
            })}
          </TransactionsContainer>
        ) : (
          <div
            style={{
              paddingBottom: '36px',
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
              flexDirection: 'column',
              flex: 1,
            }}
          >
            <Image src="/newImages/farm/noData.png" width={128} height={128} />
            <Text textAlign="center">{t('No recent transactions')}</Text>
          </div>
        )}
      </ContainerBox>
    </>
  )
}

export default WalletTransactions
